import { render, staticRenderFns } from "./ChartsdimensionBar.vue?vue&type=template&id=3f6ba76e&"
import script from "./ChartsdimensionBar.vue?vue&type=script&lang=js&"
export * from "./ChartsdimensionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports